// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================
   MAIN GRID
========================= */

.e2e_dashboard_grid{
  display:grid;

  grid-template-columns:
  repeat(3,minmax(0,1fr));

  gap:16px;

  align-items:stretch;

  margin-top:10px;
}

/* =========================
   CARD
========================= */

.e2e_card{
  height:100%;

  background:rgba(255,255,255,0.4);

  border:1px solid #ececec;

  border-radius:18px;

  padding:16px;

  box-shadow:
  0 4px 14px rgba(0,0,0,0.04);

  transition:0.3s ease;

  overflow:hidden;
}

.e2e_card:hover{
  transform:translateY(-3px);
}

.e2e_category_switch{display:flex;gap:4px;margin:0;padding:4px;border:1px solid #ded7ff;border-radius:12px;background:#f8f7ff}
.e2e_category_switch legend,.e2e_category_switch input{position:absolute;width:1px;height:1px;overflow:hidden;opacity:0}
.e2e_category_switch span{display:block;padding:8px 12px;border-radius:8px;color:#667085;font-size:12px;font-weight:700;cursor:pointer}
.e2e_category_switch label.active span{background:#5b35f5;color:#fff;box-shadow:0 4px 10px rgba(91,53,245,.25)}
.e2e_category_metrics{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px;margin-top:14px}
.e2e_category_metrics article{padding:10px;border:1px solid #eceaf7;border-radius:10px;background:#fff}
.e2e_category_metrics article>strong{display:block;margin-bottom:7px;color:#344054;font-size:12px}
.e2e_category_metrics span{display:grid;grid-template-columns:8px 1fr auto;align-items:center;gap:6px;margin-top:5px;color:#667085;font-size:10px}
.e2e_category_metrics i{width:7px;height:7px;border-radius:50%;background:#5b35f5}.e2e_category_metrics i.bench{background:#15b8a6}
.e2e_category_metrics b{color:#1f2940;font-size:12px}

/* =========================
   TITLE
========================= */

.e2e_card_title{
  font-size:16px;
  font-weight:700;

  color:#1f2940;

  margin-bottom:14px;
}

/* =========================
   CHART LAYOUT
========================= */

.e2e_chart_layout{
  display:flex;

  align-items:center;

  justify-content:space-between;

  gap:16px;
}

/* =========================
   CHART
========================= */

.e2e_chart_wrapper{
  width:160px;
  height:160px;

  position:relative;

  flex-shrink:0;

  display:flex;
  align-items:center;
  justify-content:center;
}

/* CENTER VALUES */

.e2e_chart_center{
  position:absolute;

  top:50%;
  left:50%;

  transform:translate(-50%,-50%);

  display:flex;
  flex-direction:column;

  align-items:center;
  justify-content:center;

  text-align:center;
}

.e2e_chart_center h2{
  font-size:24px;
  font-weight:800;

  color:#1f2940;

  line-height:1;
}

.e2e_chart_center p{
  margin-top:4px;

  font-size:12px;

  color:#777;
}

/* =========================
   LEGEND
========================= */

.e2e_chart_legend{
  flex:1 1;

  display:flex;
  flex-direction:column;

  gap:12px;
}

.e2e_legend_item{
  display:flex;

  align-items:center;

  justify-content:space-between;

  gap:10px;
}

.e2e_legend_left{
  display:flex;

  align-items:center;

  gap:8px;
}

.e2e_dot{
  width:10px;
  height:10px;

  border-radius:50%;
}

.e2e_legend_left p{
  font-size:13px;
  font-weight:500;

  color:#444;
}

.e2e_legend_item span{
  font-size:12px;
  font-weight:600;

  color:#666;
}

/* =========================
   SKILLS
========================= */

.e2e_skills_list{
  margin-top:10px;

  display:flex;
  flex-direction:column;

  gap:18px;
}

.e2e_skill_item{
  display:flex;

  align-items:center;

  justify-content:space-between;

  gap:12px;
}

.e2e_skill_left{
  display:flex;

  align-items:center;

  gap:10px;

  width:130px;
}

.e2e_skill_icon{
  width:32px;
  height:32px;

  border-radius:10px;

  display:flex;
  align-items:center;
  justify-content:center;

  font-size:14px;
}

.e2e_skill_left p{
  font-size:13px;
  font-weight:600;

  color:#333;
}

.e2e_skill_bar_wrapper{
  flex:1 1;

  display:flex;
  align-items:center;

  gap:10px;
}

.e2e_skill_bar_bg{
  flex:1 1;

  height:7px;

  background:#ececec;

  border-radius:20px;

  overflow:hidden;
}

.e2e_skill_bar_fill{
  height:100%;

  border-radius:20px;
}

.e2e_skill_bar_wrapper span{
  font-size:12px;
  font-weight:600;

  color:#555;
}

/* =========================
   BUTTONS
========================= */

.e2e_view_btn,
.e2e_view_all{
  border:none;

  background:#f5f3ff;

  color:#7c4dff;

  padding:7px 12px;

  border-radius:8px;

  font-size:11px;
  font-weight:600;

  cursor:pointer;

  transition:0.3s;
}

.e2e_view_btn:hover,
.e2e_view_all:hover{
  transform:translateY(-2px);
}

/* =========================
   RESPONSIVE
========================= */

@media screen and (max-width:1100px){

  .e2e_dashboard_grid{
    grid-template-columns:repeat(2,1fr);
  }
}

@media screen and (max-width:768px){

  .e2e_dashboard_grid{
    grid-template-columns:1fr;
  }

  .e2e_chart_layout{
    flex-direction:column;

    align-items:flex-start;
  }

  .e2e_chart_wrapper{
    margin:auto;
  }
}

/* =========================
   FILTER GRAPH
========================= */

.e2e_graph_filter_header{

  margin-bottom:16px;
}

.e2e_graph_filters{

  display:flex;

  align-items:flex-end;

  gap:12px;

  flex-wrap:wrap;

  margin-bottom:20px;
}

.e2e_graph_filter_item{

  display:flex;

  flex-direction:column;

  gap:6px;

  flex:1 1;

  min-width:140px;
}

.e2e_graph_filter_item label{

  font-size:12px;

  font-weight:700;

  color:#475569;
}

.e2e_graph_input,
.e2e_graph_select{

  height:42px;

  border:1px solid #dbe2ea;

  border-radius:12px;

  padding:0 12px;

  outline:none;

  background:#fff;

  font-size:13px;

  transition:0.3s ease;
}

.e2e_graph_input:focus,
.e2e_graph_select:focus{

  border-color:#4f46e5;

  box-shadow:
    0 0 0 3px rgba(79,70,229,.08);
}

.e2e_graph_apply_btn{

  height:42px;

  border:none;

  padding:0 20px;

  border-radius:12px;

  background:
    linear-gradient(
      135deg,
      #2563eb,
      #4f46e5
    );

  color:white;

  font-size:13px;

  font-weight:700;

  cursor:pointer;

  transition:0.3s;
}

.e2e_graph_apply_btn:hover{

  transform:translateY(-2px);
}

.e2e_graph_placeholder{

  height:220px;

  border:2px dashed #dbe2ea;

  border-radius:18px;

  display:flex;

  flex-direction:column;

  align-items:center;

  justify-content:center;

  text-align:center;

  background:#fafbff;
}

.e2e_graph_placeholder_icon{

  font-size:42px;

  margin-bottom:10px;
}

.e2e_graph_placeholder h4{

  margin:0;

  color:#1f2940;

  font-size:18px;

  font-weight:700;
}

.e2e_graph_placeholder p{

  margin-top:8px;

  color:#64748b;

  font-size:13px;

  max-width:280px;
}

.e2e_dashboard_grid{
  grid-template-columns:minmax(320px,1.05fr) minmax(270px,.75fr) minmax(310px,.9fr);
  gap:14px;
}
.e2e_card{
  border-radius:14px;
  background:#fff;
  border-color:#e8eaf0;
  box-shadow:0 3px 14px rgba(16,24,40,.05);
}
.e2e_insight_panel{
  padding:20px;
  border:1px solid #e8e5ff;
  border-radius:14px;
  background:linear-gradient(145deg,#fbfaff,#f7f5ff);
  color:#111b3c;
  box-shadow:0 3px 14px rgba(16,24,40,.05);
}
.e2e_insight_heading{display:flex;align-items:center;gap:9px;color:#5b21f4;font-size:13px;font-weight:800}
.e2e_insight_heading svg{width:30px;height:30px;padding:8px;border-radius:50%;background:#ebe7ff}
.e2e_insight_panel blockquote{margin:14px 0 8px;font-size:13px;font-weight:600;line-height:1.7}
.e2e_insight_signature{color:#5b21f4;font-size:12px;font-weight:700;text-align:right}
.e2e_focus_list{margin-top:15px;padding-top:13px;border-top:1px solid #dcd6ff}
.e2e_focus_list h4{display:flex;align-items:center;gap:8px;margin:0 0 10px;color:#5b21f4;font-size:12px}
.e2e_focus_list p{display:flex;align-items:center;gap:8px;margin:8px 0;color:#344054;font-size:11px;font-weight:600}
.e2e_focus_list p svg{flex:0 0 auto;color:#12b76a}

@media(max-width:1250px){.e2e_dashboard_grid{grid-template-columns:repeat(2,minmax(0,1fr))}.e2e_insight_panel{grid-column:1/-1}}
@media(max-width:768px){.e2e_dashboard_grid{grid-template-columns:1fr}.e2e_insight_panel{grid-column:auto}}

.e2e_legend_left p{display:flex;align-items:center;flex-wrap:wrap;gap:5px}
.e2e_employee_category{padding:2px 5px;border-radius:10px;background:#eeeaff;color:#6241df;font-size:8px;font-weight:800;line-height:1.2}
.e2e_employee_category.benchsales{background:#e5f8f4;color:#087f72}`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard/graphs.css"],"names":[],"mappings":"AAAA;;2BAE2B;;AAE3B;EACE,YAAY;;EAEZ;yBACuB;;EAEvB,QAAQ;;EAER,mBAAmB;;EAEnB,eAAe;AACjB;;AAEA;;2BAE2B;;AAE3B;EACE,WAAW;;EAEX,gCAAgC;;EAEhC,wBAAwB;;EAExB,kBAAkB;;EAElB,YAAY;;EAEZ;6BAC2B;;EAE3B,oBAAoB;;EAEpB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,qBAAqB,YAAY,CAAC,OAAO,CAAC,QAAQ,CAAC,WAAW,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,kBAAkB;AAC7H,uDAAuD,iBAAiB,CAAC,SAAS,CAAC,UAAU,CAAC,eAAe,CAAC,SAAS;AACvH,0BAA0B,aAAa,CAAC,gBAAgB,CAAC,iBAAiB,CAAC,aAAa,CAAC,cAAc,CAAC,eAAe,CAAC,cAAc;AACtI,uCAAuC,kBAAkB,CAAC,UAAU,CAAC,yCAAyC;AAC9G,sBAAsB,YAAY,CAAC,6CAA6C,CAAC,OAAO,CAAC,eAAe;AACxG,8BAA8B,YAAY,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,eAAe;AACtG,qCAAqC,aAAa,CAAC,iBAAiB,CAAC,aAAa,CAAC,cAAc;AACjG,2BAA2B,YAAY,CAAC,kCAAkC,CAAC,kBAAkB,CAAC,OAAO,CAAC,cAAc,CAAC,aAAa,CAAC,cAAc;AACjJ,wBAAwB,SAAS,CAAC,UAAU,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,8BAA8B,kBAAkB;AAClI,wBAAwB,aAAa,CAAC,cAAc;;AAEpD;;2BAE2B;;AAE3B;EACE,cAAc;EACd,eAAe;;EAEf,aAAa;;EAEb,kBAAkB;AACpB;;AAEA;;2BAE2B;;AAE3B;EACE,YAAY;;EAEZ,kBAAkB;;EAElB,6BAA6B;;EAE7B,QAAQ;AACV;;AAEA;;2BAE2B;;AAE3B;EACE,WAAW;EACX,YAAY;;EAEZ,iBAAiB;;EAEjB,aAAa;;EAEb,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,kBAAkB;;AAElB;EACE,iBAAiB;;EAEjB,OAAO;EACP,QAAQ;;EAER,8BAA8B;;EAE9B,YAAY;EACZ,qBAAqB;;EAErB,kBAAkB;EAClB,sBAAsB;;EAEtB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;;EAEf,aAAa;;EAEb,aAAa;AACf;;AAEA;EACE,cAAc;;EAEd,cAAc;;EAEd,UAAU;AACZ;;AAEA;;2BAE2B;;AAE3B;EACE,QAAM;;EAEN,YAAY;EACZ,qBAAqB;;EAErB,QAAQ;AACV;;AAEA;EACE,YAAY;;EAEZ,kBAAkB;;EAElB,6BAA6B;;EAE7B,QAAQ;AACV;;AAEA;EACE,YAAY;;EAEZ,kBAAkB;;EAElB,OAAO;AACT;;AAEA;EACE,UAAU;EACV,WAAW;;EAEX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;;EAEf,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;;EAEf,UAAU;AACZ;;AAEA;;2BAE2B;;AAE3B;EACE,eAAe;;EAEf,YAAY;EACZ,qBAAqB;;EAErB,QAAQ;AACV;;AAEA;EACE,YAAY;;EAEZ,kBAAkB;;EAElB,6BAA6B;;EAE7B,QAAQ;AACV;;AAEA;EACE,YAAY;;EAEZ,kBAAkB;;EAElB,QAAQ;;EAER,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;;EAEX,kBAAkB;;EAElB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;;EAEtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;;EAEf,UAAU;AACZ;;AAEA;EACE,QAAM;;EAEN,YAAY;EACZ,kBAAkB;;EAElB,QAAQ;AACV;;AAEA;EACE,QAAM;;EAEN,UAAU;;EAEV,kBAAkB;;EAElB,kBAAkB;;EAElB,eAAe;AACjB;;AAEA;EACE,WAAW;;EAEX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;;EAEf,UAAU;AACZ;;AAEA;;2BAE2B;;AAE3B;;EAEE,WAAW;;EAEX,kBAAkB;;EAElB,aAAa;;EAEb,gBAAgB;;EAEhB,iBAAiB;;EAEjB,cAAc;EACd,eAAe;;EAEf,cAAc;;EAEd,eAAe;AACjB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;2BAE2B;;AAE3B;;EAEE;IACE,mCAAmC;EACrC;AACF;;AAEA;;EAEE;IACE,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;;IAErB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;2BAE2B;;AAE3B;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;;EAEZ,oBAAoB;;EAEpB,QAAQ;;EAER,cAAc;;EAEd,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;;EAEZ,qBAAqB;;EAErB,OAAO;;EAEP,QAAM;;EAEN,eAAe;AACjB;;AAEA;;EAEE,cAAc;;EAEd,eAAe;;EAEf,aAAa;AACf;;AAEA;;;EAGE,WAAW;;EAEX,wBAAwB;;EAExB,kBAAkB;;EAElB,cAAc;;EAEd,YAAY;;EAEZ,eAAe;;EAEf,cAAc;;EAEd,oBAAoB;AACtB;;AAEA;;;EAGE,oBAAoB;;EAEpB;iCAC+B;AACjC;;AAEA;;EAEE,WAAW;;EAEX,WAAW;;EAEX,cAAc;;EAEd,kBAAkB;;EAElB;;;;;KAKG;;EAEH,WAAW;;EAEX,cAAc;;EAEd,eAAe;;EAEf,cAAc;;EAEd,eAAe;AACjB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,YAAY;;EAEZ,yBAAyB;;EAEzB,kBAAkB;;EAElB,YAAY;;EAEZ,qBAAqB;;EAErB,kBAAkB;;EAElB,sBAAsB;;EAEtB,iBAAiB;;EAEjB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;;EAEd,kBAAkB;AACpB;;AAEA;;EAEE,QAAQ;;EAER,aAAa;;EAEb,cAAc;;EAEd,eAAe;AACjB;;AAEA;;EAEE,cAAc;;EAEd,aAAa;;EAEb,cAAc;;EAEd,eAAe;AACjB;;AAEA;EACE,iFAAiF;EACjF,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,kDAAkD;EAClD,aAAa;EACb,wCAAwC;AAC1C;AACA,qBAAqB,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,aAAa,CAAC,cAAc,CAAC,eAAe;AACzG,yBAAyB,UAAU,CAAC,WAAW,CAAC,WAAW,CAAC,iBAAiB,CAAC,kBAAkB;AAChG,8BAA8B,iBAAiB,CAAC,cAAc,CAAC,eAAe,CAAC,eAAe;AAC9F,uBAAuB,aAAa,CAAC,cAAc,CAAC,eAAe,CAAC,gBAAgB;AACpF,gBAAgB,eAAe,CAAC,gBAAgB,CAAC,4BAA4B;AAC7E,mBAAmB,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,eAAe,CAAC,aAAa,CAAC,cAAc;AACvG,kBAAkB,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,YAAY,CAAC,aAAa,CAAC,cAAc,CAAC,eAAe;AACnH,sBAAsB,aAAa,CAAC,aAAa;;AAEjD,yBAAyB,oBAAoB,6CAA6C,CAAC,mBAAmB,gBAAgB,CAAC;AAC/H,wBAAwB,oBAAoB,yBAAyB,CAAC,mBAAmB,gBAAgB,CAAC;;AAE1G,mBAAmB,YAAY,CAAC,kBAAkB,CAAC,cAAc,CAAC,OAAO;AACzE,uBAAuB,eAAe,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,aAAa,CAAC,aAAa,CAAC,eAAe,CAAC,eAAe;AACxI,kCAAkC,kBAAkB,CAAC,aAAa","sourcesContent":["/* =========================\n   MAIN GRID\n========================= */\n\n.e2e_dashboard_grid{\n  display:grid;\n\n  grid-template-columns:\n  repeat(3,minmax(0,1fr));\n\n  gap:16px;\n\n  align-items:stretch;\n\n  margin-top:10px;\n}\n\n/* =========================\n   CARD\n========================= */\n\n.e2e_card{\n  height:100%;\n\n  background:rgba(255,255,255,0.4);\n\n  border:1px solid #ececec;\n\n  border-radius:18px;\n\n  padding:16px;\n\n  box-shadow:\n  0 4px 14px rgba(0,0,0,0.04);\n\n  transition:0.3s ease;\n\n  overflow:hidden;\n}\n\n.e2e_card:hover{\n  transform:translateY(-3px);\n}\n\n.e2e_category_switch{display:flex;gap:4px;margin:0;padding:4px;border:1px solid #ded7ff;border-radius:12px;background:#f8f7ff}\n.e2e_category_switch legend,.e2e_category_switch input{position:absolute;width:1px;height:1px;overflow:hidden;opacity:0}\n.e2e_category_switch span{display:block;padding:8px 12px;border-radius:8px;color:#667085;font-size:12px;font-weight:700;cursor:pointer}\n.e2e_category_switch label.active span{background:#5b35f5;color:#fff;box-shadow:0 4px 10px rgba(91,53,245,.25)}\n.e2e_category_metrics{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px;margin-top:14px}\n.e2e_category_metrics article{padding:10px;border:1px solid #eceaf7;border-radius:10px;background:#fff}\n.e2e_category_metrics article>strong{display:block;margin-bottom:7px;color:#344054;font-size:12px}\n.e2e_category_metrics span{display:grid;grid-template-columns:8px 1fr auto;align-items:center;gap:6px;margin-top:5px;color:#667085;font-size:10px}\n.e2e_category_metrics i{width:7px;height:7px;border-radius:50%;background:#5b35f5}.e2e_category_metrics i.bench{background:#15b8a6}\n.e2e_category_metrics b{color:#1f2940;font-size:12px}\n\n/* =========================\n   TITLE\n========================= */\n\n.e2e_card_title{\n  font-size:16px;\n  font-weight:700;\n\n  color:#1f2940;\n\n  margin-bottom:14px;\n}\n\n/* =========================\n   CHART LAYOUT\n========================= */\n\n.e2e_chart_layout{\n  display:flex;\n\n  align-items:center;\n\n  justify-content:space-between;\n\n  gap:16px;\n}\n\n/* =========================\n   CHART\n========================= */\n\n.e2e_chart_wrapper{\n  width:160px;\n  height:160px;\n\n  position:relative;\n\n  flex-shrink:0;\n\n  display:flex;\n  align-items:center;\n  justify-content:center;\n}\n\n/* CENTER VALUES */\n\n.e2e_chart_center{\n  position:absolute;\n\n  top:50%;\n  left:50%;\n\n  transform:translate(-50%,-50%);\n\n  display:flex;\n  flex-direction:column;\n\n  align-items:center;\n  justify-content:center;\n\n  text-align:center;\n}\n\n.e2e_chart_center h2{\n  font-size:24px;\n  font-weight:800;\n\n  color:#1f2940;\n\n  line-height:1;\n}\n\n.e2e_chart_center p{\n  margin-top:4px;\n\n  font-size:12px;\n\n  color:#777;\n}\n\n/* =========================\n   LEGEND\n========================= */\n\n.e2e_chart_legend{\n  flex:1;\n\n  display:flex;\n  flex-direction:column;\n\n  gap:12px;\n}\n\n.e2e_legend_item{\n  display:flex;\n\n  align-items:center;\n\n  justify-content:space-between;\n\n  gap:10px;\n}\n\n.e2e_legend_left{\n  display:flex;\n\n  align-items:center;\n\n  gap:8px;\n}\n\n.e2e_dot{\n  width:10px;\n  height:10px;\n\n  border-radius:50%;\n}\n\n.e2e_legend_left p{\n  font-size:13px;\n  font-weight:500;\n\n  color:#444;\n}\n\n.e2e_legend_item span{\n  font-size:12px;\n  font-weight:600;\n\n  color:#666;\n}\n\n/* =========================\n   SKILLS\n========================= */\n\n.e2e_skills_list{\n  margin-top:10px;\n\n  display:flex;\n  flex-direction:column;\n\n  gap:18px;\n}\n\n.e2e_skill_item{\n  display:flex;\n\n  align-items:center;\n\n  justify-content:space-between;\n\n  gap:12px;\n}\n\n.e2e_skill_left{\n  display:flex;\n\n  align-items:center;\n\n  gap:10px;\n\n  width:130px;\n}\n\n.e2e_skill_icon{\n  width:32px;\n  height:32px;\n\n  border-radius:10px;\n\n  display:flex;\n  align-items:center;\n  justify-content:center;\n\n  font-size:14px;\n}\n\n.e2e_skill_left p{\n  font-size:13px;\n  font-weight:600;\n\n  color:#333;\n}\n\n.e2e_skill_bar_wrapper{\n  flex:1;\n\n  display:flex;\n  align-items:center;\n\n  gap:10px;\n}\n\n.e2e_skill_bar_bg{\n  flex:1;\n\n  height:7px;\n\n  background:#ececec;\n\n  border-radius:20px;\n\n  overflow:hidden;\n}\n\n.e2e_skill_bar_fill{\n  height:100%;\n\n  border-radius:20px;\n}\n\n.e2e_skill_bar_wrapper span{\n  font-size:12px;\n  font-weight:600;\n\n  color:#555;\n}\n\n/* =========================\n   BUTTONS\n========================= */\n\n.e2e_view_btn,\n.e2e_view_all{\n  border:none;\n\n  background:#f5f3ff;\n\n  color:#7c4dff;\n\n  padding:7px 12px;\n\n  border-radius:8px;\n\n  font-size:11px;\n  font-weight:600;\n\n  cursor:pointer;\n\n  transition:0.3s;\n}\n\n.e2e_view_btn:hover,\n.e2e_view_all:hover{\n  transform:translateY(-2px);\n}\n\n/* =========================\n   RESPONSIVE\n========================= */\n\n@media screen and (max-width:1100px){\n\n  .e2e_dashboard_grid{\n    grid-template-columns:repeat(2,1fr);\n  }\n}\n\n@media screen and (max-width:768px){\n\n  .e2e_dashboard_grid{\n    grid-template-columns:1fr;\n  }\n\n  .e2e_chart_layout{\n    flex-direction:column;\n\n    align-items:flex-start;\n  }\n\n  .e2e_chart_wrapper{\n    margin:auto;\n  }\n}\n\n/* =========================\n   FILTER GRAPH\n========================= */\n\n.e2e_graph_filter_header{\n\n  margin-bottom:16px;\n}\n\n.e2e_graph_filters{\n\n  display:flex;\n\n  align-items:flex-end;\n\n  gap:12px;\n\n  flex-wrap:wrap;\n\n  margin-bottom:20px;\n}\n\n.e2e_graph_filter_item{\n\n  display:flex;\n\n  flex-direction:column;\n\n  gap:6px;\n\n  flex:1;\n\n  min-width:140px;\n}\n\n.e2e_graph_filter_item label{\n\n  font-size:12px;\n\n  font-weight:700;\n\n  color:#475569;\n}\n\n.e2e_graph_input,\n.e2e_graph_select{\n\n  height:42px;\n\n  border:1px solid #dbe2ea;\n\n  border-radius:12px;\n\n  padding:0 12px;\n\n  outline:none;\n\n  background:#fff;\n\n  font-size:13px;\n\n  transition:0.3s ease;\n}\n\n.e2e_graph_input:focus,\n.e2e_graph_select:focus{\n\n  border-color:#4f46e5;\n\n  box-shadow:\n    0 0 0 3px rgba(79,70,229,.08);\n}\n\n.e2e_graph_apply_btn{\n\n  height:42px;\n\n  border:none;\n\n  padding:0 20px;\n\n  border-radius:12px;\n\n  background:\n    linear-gradient(\n      135deg,\n      #2563eb,\n      #4f46e5\n    );\n\n  color:white;\n\n  font-size:13px;\n\n  font-weight:700;\n\n  cursor:pointer;\n\n  transition:0.3s;\n}\n\n.e2e_graph_apply_btn:hover{\n\n  transform:translateY(-2px);\n}\n\n.e2e_graph_placeholder{\n\n  height:220px;\n\n  border:2px dashed #dbe2ea;\n\n  border-radius:18px;\n\n  display:flex;\n\n  flex-direction:column;\n\n  align-items:center;\n\n  justify-content:center;\n\n  text-align:center;\n\n  background:#fafbff;\n}\n\n.e2e_graph_placeholder_icon{\n\n  font-size:42px;\n\n  margin-bottom:10px;\n}\n\n.e2e_graph_placeholder h4{\n\n  margin:0;\n\n  color:#1f2940;\n\n  font-size:18px;\n\n  font-weight:700;\n}\n\n.e2e_graph_placeholder p{\n\n  margin-top:8px;\n\n  color:#64748b;\n\n  font-size:13px;\n\n  max-width:280px;\n}\n\n.e2e_dashboard_grid{\n  grid-template-columns:minmax(320px,1.05fr) minmax(270px,.75fr) minmax(310px,.9fr);\n  gap:14px;\n}\n.e2e_card{\n  border-radius:14px;\n  background:#fff;\n  border-color:#e8eaf0;\n  box-shadow:0 3px 14px rgba(16,24,40,.05);\n}\n.e2e_insight_panel{\n  padding:20px;\n  border:1px solid #e8e5ff;\n  border-radius:14px;\n  background:linear-gradient(145deg,#fbfaff,#f7f5ff);\n  color:#111b3c;\n  box-shadow:0 3px 14px rgba(16,24,40,.05);\n}\n.e2e_insight_heading{display:flex;align-items:center;gap:9px;color:#5b21f4;font-size:13px;font-weight:800}\n.e2e_insight_heading svg{width:30px;height:30px;padding:8px;border-radius:50%;background:#ebe7ff}\n.e2e_insight_panel blockquote{margin:14px 0 8px;font-size:13px;font-weight:600;line-height:1.7}\n.e2e_insight_signature{color:#5b21f4;font-size:12px;font-weight:700;text-align:right}\n.e2e_focus_list{margin-top:15px;padding-top:13px;border-top:1px solid #dcd6ff}\n.e2e_focus_list h4{display:flex;align-items:center;gap:8px;margin:0 0 10px;color:#5b21f4;font-size:12px}\n.e2e_focus_list p{display:flex;align-items:center;gap:8px;margin:8px 0;color:#344054;font-size:11px;font-weight:600}\n.e2e_focus_list p svg{flex:0 0 auto;color:#12b76a}\n\n@media(max-width:1250px){.e2e_dashboard_grid{grid-template-columns:repeat(2,minmax(0,1fr))}.e2e_insight_panel{grid-column:1/-1}}\n@media(max-width:768px){.e2e_dashboard_grid{grid-template-columns:1fr}.e2e_insight_panel{grid-column:auto}}\n\n.e2e_legend_left p{display:flex;align-items:center;flex-wrap:wrap;gap:5px}\n.e2e_employee_category{padding:2px 5px;border-radius:10px;background:#eeeaff;color:#6241df;font-size:8px;font-weight:800;line-height:1.2}\n.e2e_employee_category.benchsales{background:#e5f8f4;color:#087f72}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
